export type TopicReadWarmCandidate = {
  id: string
  closed?: boolean | null
  unread?: number | null
  last_message_ts?: number | null
  created_at?: number | null
}

function topicActivity(topic: TopicReadWarmCandidate): number {
  return topic.last_message_ts ?? topic.created_at ?? 0
}

export function selectTopicReadWarmTargets<Topic extends TopicReadWarmCandidate>(
  topics: readonly Topic[],
  limit: number,
): Topic[] {
  const max = Math.max(0, Math.floor(limit))
  if (max === 0) return []

  return [...topics]
    .filter((topic) => !topic.closed)
    .sort((a, b) => {
      const unreadDelta = (b.unread ?? 0) - (a.unread ?? 0)
      if (unreadDelta !== 0) return unreadDelta
      return topicActivity(b) - topicActivity(a)
    })
    .slice(0, max)
}
